import React, { useState } from "react";
import {
  Button,
  ButtonGroup,
  Col,
  Container,
  Form,
  Row,
  Table,
} from "react-bootstrap";
import { FaPlusSquare } from "react-icons/fa";
import { FaMinusSquare } from "react-icons/fa";
import { LiaWindowClose } from "react-icons/lia";
import { useNavigate, useParams } from "react-router-dom";
import { deepComparison } from "../utils/constants";
import { toast } from "wc-toast";
import { apiGet, apiPost } from "../utils/apiFetch";
import apiPath from "../utils/apiPath";
import { useEffect } from "react";
import { isEmpty } from "lodash";
const CasinoNew = () => {
  const [dropdown, setDropdown] = useState(false);
  const [dropdownEvo, setDropdownEvo] = useState(false);
  const [dropdownAviator, setDropdownAviator] = useState(false);
  const [dropdownEzugi, setDropdownEzugi] = useState(false);
  const [dropdownVivo, setDropdownVivo] = useState(false);
  const [dropdownLive, setDropdownLive] = useState(false);
  const parmas = useParams();
  let defaultData = {
    Provider: {
      IndianPoker: false,
      Evolution: false,
      Aviator: false,
      Vivo: false,
      Ezugi: false,
      Live: false,
    },
    Game: {
      IndianPoker: {
        sevenUp_sevenDown: false,
        Teenpati: false,
        Teenpati_T20: false,
        Dragon_Tiger: false,
        Higher_Lower: false,
        Worli_Matka: false,
        thirtytwo_Card_Casion: false,
        Andhar_Bahar: false,
        Amar_Akbar_Anthoy: false,
        Race_20_20: false,
        Bollywood_Casino: false,
        Six_Player_Poke: false,
        Roulette: false,
        Sicbo: false,
        Muflis_Teenpati: false,
        Trio: false,
        Baccarat: false,
        Casino_Meter: false,
        twenty_Poker: false,
        two_Card_Teenpati: false,
        Casino_War: false,
        The_Trap: false,
        Open_Teenpati: false,
        twenty_Card_Baccarat: false,
        Race_to_seventen: false,
        Roulette: false,
        Daragon_Tiger: false,
      },
      Evolution: {
        Evolution: false,
        Sicbo: false,
        Football_French_Roulette: false,
        Casino_Hold: false,
        Baccarat_Live: false,
        Andhar_Baha: false,
        Lightning_Baccarat_First_Person: false,
        Speed_Auto_Roulette: false,
        Cash_or_Crash: false,
        Mega_Ball: false,
        Auto_Roulette: false,
        Speed_Auto_Roulette: false,
        Roulette: false,
        Triple_Card_Poker: false,
        Lightning_Dice: false,
        Dragon_Tiger: false,
        Roulette: false,
        Lightning_Lotto: false,
        King_Slot: false,
      },
      Aviator: {
        Aviator: false,
        AviatorX: false,
      },
      Ezugi: {
        Ezugi_Lobby: false,
        Sic_Bo: false,
        Grand_Wheel: false,
        Dead_and_Alive: false,
        thirtytwo_Cards: false,
        Andhar_Bahar: false,
        Teen_Patti: false,
        Speed_Auto_Roulette: false,
        Unlimitaed_Blackjack: false,
        Kingmaker_Keno: false,
        Namaster_Roulette: false,
        VIP_Blackjack: false,
        Lucky_seven: false,
        Diamond_Roulette: false,
        Devil_Number: false,
        Atlantis: false,
        Mega_Dragon: false,
        Lucky_Wizard: false,
        VIP_Fortune_Baccarat: false,
        Baccarat_Pro: false,
        Royal_Race: false,
        Cricket_War: false,
      },
      Vivo: {
        Baxxarat: false,
        Casino_Holdem: false,
        Dragon_Tiger: false,
        Quence_Baccarat: false,
        Live_Baccarat: false,
        Sunmacad_Baccarat: false,
        Blackjakck: false,
      },
      Live: {
        Plinko: false,
        Cricket_Baccarat: false,
        Baccarat_Live: false,
        Cappadqcia: false,
        Baccarat_Pro: false,
        FIesta_Baccarat: false,
        Super_six_Baccarat: false,
        Dragon_Tiger: false,
        Circket_War: false,
        Bacarat_one: false,
        Baccarat_ten: false,
        Baccarat_three: false,
        Black_Jack: false,
      },
    },
  };
  const [data, setData] = useState(defaultData);
  const onSubmit = async () => {
    if (deepComparison(defaultData, data)) {
      toast.error("Pleae enter some input to fields");
    } else {
      const { status, data: response_users } = await apiPost(
        apiPath.casinoControl,
        { userId: parmas?.id, userType: parmas?.type, result: data }
      );
      if (status === 200) {
        if (response_users.success) {
          getData()
        }
      }
    }
  };
  const reset = () => {
    setData(defaultData);
  };
  const navigate = useNavigate();

  const handelChange = (value, type, inner) => {
    setData((prev) => {
      return {
        ...prev,
        [value]:
          value == "Provider"
            ? { ...prev[value], [type]: !prev[value][type] }
            : {
                ...prev[value],
                [inner]: {
                  ...prev[value][inner],
                  [type]: !prev[value][inner][type],
                },
              },
      };
    });
  };

  const getData = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.getcasinoControl,
      {
        userId: parmas?.id,
        userType: parmas?.type,
      }
    );
    if (status === 200) {
      if (response_users.success) {
        let result = response_users?.results;
        if(!isEmpty(result)){
        setData((prev) => {
          return {
            ...prev,
            Provider: Object.fromEntries(
              result?.providers?.map((t) => [t.name, t.isBlocked])
            ),
    
            Game: {
              IndianPoker: Object.fromEntries(
                result?.providers
                  ?.find((res) => {
                    return res?.name == "IndianPoker";
                  })
                  ?.games?.map((t) => [t.name, t.isBlocked])
              ),
              Evolution: Object.fromEntries(
                result?.providers
                  ?.find((res) => {
                    return res?.name == "Evolution";
                  })
                  ?.games?.map((t) => [t.name, t.isBlocked])
              ),
              Aviator: Object.fromEntries(
                result?.providers
                  ?.find((res) => {
                    return res?.name == "Aviator";
                  })
                  ?.games?.map((t) => [t.name, t.isBlocked])
              ),
              Ezugi: Object.fromEntries(
                result?.providers
                  ?.find((res) => {
                    return res?.name == "Ezugi";
                  })
                  ?.games?.map((t) => [t.name, t.isBlocked])
              ),
              Vivo: Object.fromEntries(
                result?.providers
                  ?.find((res) => {
                    return res?.name == "Vivo";
                  })
                  ?.games?.map((t) => [t.name, t.isBlocked])
              ),
              Live: Object.fromEntries(
                result?.providers
                  ?.find((res) => {
                    return res?.name == "Live";
                  })
                  ?.games?.map((t) => [t.name, t.isBlocked])
              ),
            },
          };
        });}
      }
    }
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <section className="find-member-sec">
      <Container fluid>
        <div className="d-flex justify-content-end mt-2">
          {" "}
          <Button className="btn btn-danger" onClick={() => navigate(-1)}>
            Close
          </Button>
        </div>
        <Row className="mb-md-0 mb-3 p-3">
          <div className="casino-control-outer">
            <p>Providers -</p>
            <div className="casino-control">
              {firstDataList?.map((res) => {
                return (
                  <div>
                    <span>{res?.value}</span>
                    <span class="betlock1">
                      <label class="checkboxx">
                        <input
                          onChange={(e) => {
                            handelChange("Provider", res?.key);
                          }}
                          checked={data.Provider[res?.key]}
                          type="checkbox"
                        />
                        <span class="checkmark1"></span>
                      </label>
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </Row>
        <Row className="mb-md-0 mb-3 p-3">
          <div className="casino-control-outer">
            <p>Casino Control -</p>
            <div className="casino-control-bottom-outer">
              <div className="casino-control-bottom">
                {dropdown ? (
                  <FaMinusSquare
                    onClick={() => setDropdown(!dropdown)}
                    style={{ marginRight: "10px" }}
                    size={18}
                  />
                ) : (
                  <FaPlusSquare
                    onClick={() => setDropdown(!dropdown)}
                    style={{ marginRight: "10px" }}
                    size={18}
                  />
                )}
                <span>Indain Poker</span>
              </div>
              {dropdown && (
                <div className="casino-control-bottom-detail">
                  {IndianPoker.map((res) => {
                    return (
                      <div>
                        <LiaWindowClose size={20} />
                        <span>{res.value}</span>
                        <span class="betlock1">
                          <label class="checkboxx">
                            <input
                              checked={data?.Game?.IndianPoker[res?.key]}
                              onChange={(e) => {
                                handelChange("Game", res.key, "IndianPoker");
                              }}
                              type="checkbox"
                            />
                            <span class="checkmark1"></span>
                          </label>
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            <div className="casino-control-bottom-outer">
              <div className="casino-control-bottom">
                {dropdownEvo ? (
                  <FaMinusSquare
                    onClick={() => setDropdownEvo(!dropdownEvo)}
                    style={{ marginRight: "10px" }}
                    size={18}
                  />
                ) : (
                  <FaPlusSquare
                    onClick={() => setDropdownEvo(!dropdownEvo)}
                    style={{ marginRight: "10px" }}
                    size={18}
                  />
                )}
                <span>Evolution</span>
              </div>
              {dropdownEvo && (
                <div className="casino-control-bottom-detail">
                  {Evolution.map((res) => {
                    return (
                      <div>
                        <LiaWindowClose size={20} />
                        <span>{res.value}</span>
                        <span class="betlock1">
                          <label class="checkboxx">
                            <input
                              checked={data?.Game?.Evolution[res?.key]}
                              onChange={(e) => {
                                handelChange("Game", res.key, "Evolution");
                              }}
                              type="checkbox"
                            />
                            <span class="checkmark1"></span>
                          </label>
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            <div className="casino-control-bottom-outer">
              <div className="casino-control-bottom">
                {dropdownAviator ? (
                  <FaMinusSquare
                    onClick={() => setDropdownAviator(!dropdownAviator)}
                    style={{ marginRight: "10px" }}
                    size={18}
                  />
                ) : (
                  <FaPlusSquare
                    onClick={() => setDropdownAviator(!dropdownAviator)}
                    style={{ marginRight: "10px" }}
                    size={18}
                  />
                )}
                <span>Aviator</span>
              </div>
              {dropdownAviator && (
                <div className="casino-control-bottom-detail">
                  {Aviator.map((res) => {
                    return (
                      <div>
                        <LiaWindowClose size={20} />
                        <span>{res.value}</span>
                        <span class="betlock1">
                          <label class="checkboxx">
                            <input
                              checked={data?.Game?.Aviator[res?.key]}
                              onChange={(e) => {
                                handelChange("Game", res.key, "Aviator");
                              }}
                              type="checkbox"
                            />
                            <span class="checkmark1"></span>
                          </label>
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            <div className="casino-control-bottom-outer">
              <div className="casino-control-bottom">
                {dropdownEzugi ? (
                  <FaMinusSquare
                    onClick={() => setDropdownEzugi(!dropdownEzugi)}
                    style={{ marginRight: "10px" }}
                    size={18}
                  />
                ) : (
                  <FaPlusSquare
                    onClick={() => setDropdownEzugi(!dropdownEzugi)}
                    style={{ marginRight: "10px" }}
                    size={18}
                  />
                )}
                <span>Ezugi</span>
              </div>
              {dropdownEzugi && (
                <div className="casino-control-bottom-detail">
                  {Ezugi.map((res) => {
                    return (
                      <div>
                        <LiaWindowClose size={20} />
                        <span>{res.value}</span>
                        <span class="betlock1">
                          <label class="checkboxx">
                            <input
                              checked={data?.Game?.Ezugi[res?.key]}
                              onChange={(e) => {
                                handelChange("Game", res.key, "Ezugi");
                              }}
                              type="checkbox"
                            />
                            <span class="checkmark1"></span>
                          </label>
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            <div className="casino-control-bottom-outer">
              <div className="casino-control-bottom">
                {dropdownVivo ? (
                  <FaMinusSquare
                    onClick={() => setDropdownVivo(!dropdownVivo)}
                    style={{ marginRight: "10px" }}
                    size={18}
                  />
                ) : (
                  <FaPlusSquare
                    onClick={() => setDropdownVivo(!dropdownVivo)}
                    style={{ marginRight: "10px" }}
                    size={18}
                  />
                )}
                <span>Vivo</span>
              </div>
              {dropdownVivo && (
                <div className="casino-control-bottom-detail">
                  {Vivo.map((res) => {
                    return (
                      <div>
                        <LiaWindowClose size={20} />
                        <span>{res.value}</span>
                        <span class="betlock1">
                          <label class="checkboxx">
                            <input
                              checked={data?.Game?.Vivo[res?.key]}
                              onChange={(e) => {
                                handelChange("Game", res.key, "Vivo");
                              }}
                              type="checkbox"
                            />
                            <span class="checkmark1"></span>
                          </label>
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            <div className="casino-control-bottom-outer">
              <div className="casino-control-bottom">
                {dropdownLive ? (
                  <FaMinusSquare
                    onClick={() => setDropdownLive(!dropdownLive)}
                    style={{ marginRight: "10px" }}
                    size={18}
                  />
                ) : (
                  <FaPlusSquare
                    onClick={() => setDropdownLive(!dropdownLive)}
                    style={{ marginRight: "10px" }}
                    size={18}
                  />
                )}
                <span>Live</span>
              </div>
              {dropdownLive && (
                <div className="casino-control-bottom-detail">
                  {Live.map((res) => {
                    return (
                      <div>
                        <LiaWindowClose size={20} />
                        <span>{res.value}</span>
                        <span class="betlock1">
                          <label class="checkboxx">
                            <input
                              checked={data?.Game?.Live[res?.key]}
                              onChange={(e) => {
                                handelChange("Game", res.key, "Live");
                              }}
                              type="checkbox"
                            />
                            <span class="checkmark1"></span>
                          </label>
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </Row>
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <Button className="green-btn" onClick={() => onSubmit()}>
              Submit
            </Button>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default CasinoNew;

const firstDataList = [
  {
    value: "Indain Poker",
    key: "IndianPoker",
  },
  {
    value: "Evolution",
    key: "Evolution",
  },
  {
    value: "Aviator",
    key: "Aviator",
  },
  {
    value: "Vivo",
    key: "Vivo",
  },
  {
    value: "Ezugi",
    key: "Ezugi",
  },
  {
    value: "Live",
    key: "Live",
  },
];

const IndianPoker = [
  { value: "7 Up & 7 Down", key: "sevenUp_sevenDown" },
  { value: "Teenpati", key: "Teenpati" },
  { value: "Teenpati T20", key: "Teenpati_T20" },
  { value: "Dragon Tiger", key: "Dragon_Tiger" },
  { value: "Higher Lower", key: "Higher_Lower" },
  { value: "Worli Matka", key: "Worli_Matka" },
  { value: "32 Card Casion", key: "thirtytwo_Card_Casion" },
  { value: "Andhar Bahar", key: "Andhar_Bahar" },
  { value: "Amar Akbar Anthoy", key: "Amar_Akbar_Anthoy" },
  { value: "Race 20-20", key: "Race_20_20" },
  { value: "Bollywood Casino", key: "Bollywood_Casino" },
  { value: "Six Player Poker", key: "Six_Player_Poke" },
  { value: "Roulette", key: "Roulette" },
  { value: "Sicbo", key: "Sicbo" },
  { value: "Muflis Teenpati", key: "Muflis_Teenpati" },
  { value: "Trio", key: "Trioo" },
  { value: "Baccarat", key: "Baccarat" },
  { value: "Casino Meter", key: "Casino_Meter" },
  { value: "20-20 Poker", key: "twenty_Poker" },
  { value: "2 Card Teenpati", key: "two_Card_Teenpati" },
  { value: "Casino War", key: "Casino_War" },
  { value: "The Trap", key: "The_Trap" },
  { value: "Open Teenpati", key: "Open_Teenpati" },
  { value: "29 Card Baccarat", key: "twenty_Card_Baccarat" },
  { value: "Race to 17", key: "Race_to_seventen" },
  { value: "Roulette", key: "Roulette" },
  { value: "Daragon Tiger", key: "Daragon_Tiger" },
];

const Evolution = [
  { value: "Evolution", key: "Evolution" },
  { value: "Sicbo", key: "Sicbo" },
  { value: "Football French Roulette", key: "Football_French_Roulette" },
  { value: "Casino Hold", key: "Casino_Hold" },
  { value: "Baccarat Live", key: "Baccarat_Live" },
  { value: "Andhar Baha", key: "Andhar_Baha" },
  {
    value: "Lightning Baccarat First Person",
    key: "Lightning_Baccarat_First_Person",
  },
  { value: "Speed Auto Roulette", key: "Speed_Auto_Roulette" },
  { value: "Cash or Crash", key: "Cash_or_Crash" },
  { value: "Mega Ball", key: "Mega_Ball" },
  { value: "Auto Roulette", key: "Auto_Roulette" },
  { value: "Speed Auto Roulette", key: "Speed_Auto_Roulette" },
  { value: "Roulette", key: "Roulette" },
  { value: "Triple Card Poker", key: "Triple_Card_Poker" },
  { value: "Lightning Dice", key: "Lightning_Dice" },
  { value: "Dragon Tiger", key: "Dragon_Tiger" },
  { value: "Roulette", key: "Roulette" },
  { value: "Lightning Lotto", key: "Lightning_Lotto" },
  { value: "King Slot", key: "King_Slot" },
];
const Aviator = [
  { value: "Aviator", key: "Aviator" },
  { value: "AviatorX", key: "AviatorX" },
];
const Ezugi = [
  { value: "Ezugi Lobby", key: "Ezugi_Lobby" },
  { value: "Sic Bo", key: "Sic_Bo" },
  { value: "Grand Wheel", key: "Grand_Wheel" },
  { value: "Dead and Alive", key: "Dead_and_Alive" },
  { value: "32 Cards", key: "thirtytwo_Cards" },
  { value: "Andhar Bahar", key: "Andhar_Bahar" },
  { value: "Teen Patti", key: "Teen_Patti" },
  { value: "Speed Auto ROulette", key: "Speed_Auto_Roulette" },
  { value: "Unlimitaed Blackjack", key: "Unlimitaed_Blackjack" },
  { value: "Kingmaker Keno", key: "Kingmaker_Keno" },
  { value: "Namaster Roulette", key: "Namaster_Roulette" },
  { value: "VIP Blackjack", key: "VIP_Blackjack" },
  { value: "Lucky 7", key: "Lucky_seven" },
  { value: "Diamond Roulette", key: "Diamond_Roulette" },
  { value: "Devil Number", key: "Devil_Number" },
  { value: "Atlantis", key: "Atlantis" },
  { value: "Mega Dragon", key: "Mega_Dragon" },
  { value: "Lucky Wizard", key: "Lucky_Wizard" },
  { value: "VIP Fortune Baccarat", key: "VIP_Fortune_Baccarat" },
  { value: "Baccarat Pro", key: "Baccarat_Pro" },
  { value: "Royal Race", key: "Royal_Race" },
  { value: "ricket War", key: "Cricket_War" },
];
const Vivo = [
  { value: "Baxxarat", key: "Baxxarat" },
  { value: "Casino Holdem", key: "Casino_Holdem" },
  { value: "Dragon Tiger", key: "Dragon_Tiger" },
  { value: "Quence Baccarat", key: "Quence_Baccarat" },
  { value: "Live Baccarat", key: "Live_Baccarat" },
  { value: "Sunmacad Baccarat", key: "Sunmacad_Baccarat" },
  { value: "Blackjack", key: "Blackjack" },
];
const Live = [
  { value: "Plinko", key: "Plinko" },
  { value: "Cricket Baccarat", key: "Cricket_Baccarat" },
  { value: "Baccarat Live", key: "Baccarat_Live" },
  { value: "Cappadqcia", key: "Cappadqcia" },
  { value: "Baccarat Pro", key: "Baccarat_Pro" },
  { value: "FIesta Baccarat", key: "FIesta_Baccarat" },
  { value: "Super 6 Baccarat", key: "Super_six_Baccarat" },
  { value: "Dragon Tiger", key: "Dragon_Tiger" },
  { value: "Circket War", key: "Circket_War" },
  { value: "Bacarat 1", key: "Bacarat_one" },
  { value: "Baccarat 10", key: "Baccarat_ten" },
  { value: "Baccarat 3", key: "Baccarat_three" },
  { value: "Black Jack", key: "Black_Jack" },
];
